import { number_format } from '@/api/filter';
import { find } from 'lodash';

export const config = {
    data() {
        return {
            searchParams: {},
            columns: [],
            calculateTypeList: [
                {
                    value: 'all',
                    label: '全部'
                },
                {
                    value: '1',
                    label: '按承保'
                },
                {
                    value: '2',
                    label: '按实收'
                }
            ],
            calculateList: [
                {
                    value: '1',
                    label: '年度R13',
                    rateMode: '1',
                    calculateIndex: '1'
                },
                {
                    value: '2',
                    label: '年度R25',
                    rateMode: '1',
                    calculateIndex: '2',
                    lastLabel: '年度R13'
                },
                {
                    value: '3',
                    label: '年度R37',
                    rateMode: '1',
                    calculateIndex: '3',
                    lastLabel: '年度R25'
                },
                {
                    value: '4',
                    label: '年度R49',
                    rateMode: '1',
                    calculateIndex: '4',
                    lastLabel: '年度R37'
                },
                {
                    value: '5',
                    label: '月度R13',
                    rateMode: '2',
                    calculateIndex: '1'
                },
                {
                    value: '6',
                    label: '月度R25',
                    rateMode: '2',
                    calculateIndex: '2',
                    lastLabel: '月度R13'
                },
                {
                    value: '7',
                    label: '月度R37',
                    rateMode: '2',
                    calculateIndex: '3',
                    lastLabel: '月度R25'
                },
                {
                    value: '8',
                    label: '月度R49',
                    rateMode: '2',
                    calculateIndex: '4',
                    lastLabel: '月度R37'
                }
            ]
        };
    },
    methods: {
        /**
         *
         * @param {Stirng} type 继续率类型 1 上游 2机构 3团队 4个人 5渠道
         * @return {object}
         */
        setSearchParams(type) {
            let data = {
                //默认项
                calculate: '1',
                rateMode: '1',
                calculateIndex: '1',
                target: '1', //继续率对象（1、整体继续率 2、产品继续率）
                calculateType: 'all', //计算方式 1、按承保2、安实收
                date: new Date(),
                month: new Date().getMonth() + 1,
                year: new Date().getFullYear()
                //默认项 end
            };
            if (type == 1) {
                return {
                    ...data,
                    owerType: '1' // 1、保司2、通道 3、机构 4、渠道
                };
            } else if (type == 2) {
                return {
                    ...data,
                    owerType: '3', // 1、保司2、通道 3、机构 4、渠道
                    supplierType: 'all', //供应商分组（用于机构继续率，团队继续率、个人继续率）1、保司 2、通道
                    hasSubOrg: '1', //是否包含下级机构 默认包含
                    name: '' //机构tree 回显name
                };
            } else if (type == 3) {
                return {
                    ...data,
                    owerType: '3', // 1、保司2、通道 3、机构 4、渠道
                    supplierType: 'all', //供应商分组（用于机构继续率，团队继续率、个人继续率）1、保司 2、通道
                    hasSubOrg: '1', //是否包含下级机构 默认包含
                    groupByType: '1', //机构继续率分组（1、机构团队继续率 2、机构个人继续率）
                    groupIds: [], //团队
                    name: '' //机构tree 回显name
                };
            } else if (type == 4) {
                return {
                    ...data,
                    owerType: '3', // 1、保司2、通道 3、机构 4、渠道
                    supplierType: 'all', //供应商分组（用于机构继续率，团队继续率、个人继续率）1、保司 2、通道
                    groupByType: '2', //机构继续率分组（1、机构团队继续率 2、机构个人继续率）
                    groupIds: [], //团队
                    name: '' //机构tree 回显name
                };
            } else if (type == 5) {
                return {
                    ...data,
                    owerType: '4', // 1、保司2、通道 3、机构 4、渠道
                    supplierType: 'all', //供应商分组（用于机构继续率，团队继续率、个人继续率）1、保司 2、通道
                    hasSubOrg: '1', //是否包含下级机构 默认包含
                    groupIds: [], //团队
                    name: '' //机构tree 回显name
                };
            }
        },
        /**
         *
         * @param {Stirng} type 继续率类型 1 上游 2机构 3团队 4个人 5渠道
         * @return {object[]}
         */
        setOwerTypeList(type) {
            let map = {
                2: '机构',
                3: '团队',
                4: '个人',
                5: '渠道'
            };
            if (type == 1) {
                return [
                    {
                        value: '1',
                        label: '保司继续率'
                    },
                    {
                        value: '2',
                        label: '通道继续率'
                    }
                ];
            } else {
                return [
                    {
                        value: 'all',
                        label: `${map[type]}继续率`
                    },
                    // {
                    //     value: '1',
                    //     label: `${map[type]}保司继续率`
                    // },
                    // {
                    //     value: '2',
                    //     label: `${map[type]}通道继续率`
                    // }
                ];
            }
        },
        getColumns() {
            let vm = this;
            let calculate = this.calculateList[this.searchParams.calculate - 1].label;
            let lastLabel = this.calculateList[this.searchParams.calculate - 1].lastLabel;
            let map = {
                1: '保险公司',
                2: '通道公司',
                3: '机构名称',
                4: '渠道名称'
            };
            if (this.columns.length) {
                // 存在columns  重置columns title
                this.columns.forEach(item => {
                    if (item.calcTtile) {
                        item.title = item.calcTtile(calculate);
                    }
                    if (item.calcTtile1 && lastLabel) {
                        item.title = item.calcTtile1(lastLabel);
                    }
                });
            }
            // else {
            if (this.type == 1) {
                this.columns = [
                    {
                        type: 'index',
                        title: '序号',
                        align: 'center',
                        width: '80'
                    },
                    {
                        title: '继续率月份',
                        key: 'month',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span>
                                    {row.year}-{row.month < 10 ? '0' + row.month : row.month}
                                </span>
                            );
                        }
                    },
                    {
                        title: map[this.searchParams.owerType],
                        calcTtile: () => {
                            return map[this.searchParams.owerType];
                        },
                        key: 'owerName',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: '继续率指标',
                        slot: 'rateMode',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: '继续率',
                        key: 'rate',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return <span>{row.rate}%</span>;
                        }
                    },
                    {
                        title: calculate + '承保保费（元）',
                        calcTtile: name => {
                            return name + '承保保费（元）';
                        },
                        key: 'insureFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                return (
                                    <span onClick={() => vm.goPolicyList(1, row)} class="can-click">
                                        {number_format(row.insureFee, 2)}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '承保数据范围',
                        calcTtile: name => {
                            return name + '承保数据范围';
                        },
                        key: 'insureTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                const date = row.insureTimeBegin.substring(0, 10);
                                const endDate = row.insureTimeEnd.substring(0, 10);
                                return (
                                    <span>
                                        {date} 至 {endDate}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '实收保费（元）',
                        calcTtile: name => {
                            return name + '实收保费（元）';
                        },
                        key: 'receiptFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span onClick={() => vm.goPolicyList(2, row)} class="can-click">
                                    {number_format(row.receiptFee, 2)}
                                </span>
                            );
                        }
                    },
                    {
                        title: calculate + '实收数据范围',
                        calcTtile: name => {
                            return name + '实收数据范围';
                        },
                        key: 'receiptTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            const date = row.receiptTimeBegin.substring(0, 10);
                            const endDate = row.receiptTimeEnd.substring(0, 10);
                            return (
                                <span>
                                    {date} 至 {endDate}
                                </span>
                            );
                        }
                    }
                    // {
                    //     title: '操作',
                    //     slot: 'action',
                    //     align: 'center',
                    //     width: '100',
                    //     fixed: 'right'
                    // }
                ];
            } else if (this.type == 2) {
                this.columns = [
                    {
                        type: 'index',
                        title: '序号',
                        align: 'center',
                        width: '80'
                    },
                    {
                        title: '继续率月份',
                        key: 'month',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span>
                                    {row.year}-{row.month < 10 ? '0' + row.month : row.month}
                                </span>
                            );
                        }
                    },
                    {
                        title: map[this.searchParams.owerType],
                        calcTtile: () => {
                            console.log('----', map[this.searchParams.owerType]);
                            return map[this.searchParams.owerType];
                        },
                        key: 'owerName',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: '是否包含下级机构数据',
                        key: 'hasSubOrg',
                        minWidth: 160,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return <span>{vm.searchParams.hasSubOrg == 1 ? '是' : '否'}</span>;
                        }
                    },
                    {
                        title: '继续率指标',
                        slot: 'rateMode',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: '继续率',
                        key: 'rate',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return <span>{row.rate}%</span>;
                        }
                    },
                    {
                        title: calculate + '承保保费（元）',
                        calcTtile: name => {
                            return name + '承保保费（元）';
                        },
                        key: 'insureFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                return (
                                    <span onClick={() => vm.goPolicyList(1, row)} class="can-click">
                                        {number_format(row.insureFee, 2)}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '承保数据范围',
                        calcTtile: name => {
                            return name + '承保数据范围';
                        },
                        key: 'insureTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                const date = row.insureTimeBegin.substring(0, 10);
                                const endDate = row.insureTimeEnd.substring(0, 10);
                                return (
                                    <span>
                                        {date} 至 {endDate}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '实收保费（元）',
                        calcTtile: name => {
                            return name + '实收保费（元）';
                        },
                        key: 'receiptFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span onClick={() => vm.goPolicyList(2, row)} class="can-click">
                                    {number_format(row.receiptFee, 2)}元
                                </span>
                            );
                        }
                    },
                    {
                        title: calculate + '实收数据范围',
                        calcTtile: name => {
                            return name + '实收数据范围';
                        },
                        key: 'receiptTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const date = params.row.receiptTimeBegin.substring(0, 10);
                            const endDate = params.row.receiptTimeEnd.substring(0, 10);
                            return (
                                <span>
                                    {date} 至 {endDate}
                                </span>
                            );
                        }
                    }
                    // {
                    //     title: '操作',
                    //     slot: 'action',
                    //     align: 'center',
                    //     width: '100',
                    //     fixed: 'right'
                    // }
                ];
            } else if (this.type == 3) {
                this.columns = [
                    {
                        type: 'index',
                        title: '序号',
                        align: 'center',
                        width: '80'
                    },
                    {
                        title: '继续率月份',
                        key: 'month',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span>
                                    {row.year}-{row.month < 10 ? '0' + row.month : row.month}
                                </span>
                            );
                        }
                    },
                    {
                        title: map[this.searchParams.owerType],
                        calcTtile: () => {
                            return map[this.searchParams.owerType];
                        },
                        key: 'owerName',
                        minWidth: 180,
                        align: 'center'
                    },
                    {
                        title: '团队名称',
                        key: 'groupName',
                        minWidth: 200,
                        align: 'center'
                    },
                    {
                        title: '团队负责人',
                        key: 'leaderName',
                        minWidth: 180,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span>
                                    {row.leaderName} / {row.leaderStaff}
                                </span>
                            );
                        }
                    },
                    {
                        title: '是否包含下级团队数据',
                        key: 'hasSubOrg',
                        minWidth: 160,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return <span>{vm.searchParams.hasSubOrg == 1 ? '是' : '否'}</span>;
                        }
                    },
                    {
                        title: '继续率指标',
                        slot: 'rateMode',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: '继续率',
                        key: 'rate',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return <span>{row.rate}%</span>;
                        }
                    },
                    {
                        title: calculate + '承保保费（元）',
                        calcTtile: name => {
                            return name + '承保保费（元）';
                        },
                        key: 'insureFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                return (
                                    <span onClick={() => vm.goPolicyList(1, row)} class="can-click">
                                        {number_format(row.insureFee, 2)}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '承保数据范围',
                        calcTtile: name => {
                            return name + '承保数据范围';
                        },
                        key: 'insureTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                const date = row.insureTimeBegin.substring(0, 10);
                                const endDate = row.insureTimeEnd.substring(0, 10);
                                return (
                                    <span>
                                        {date} 至 {endDate}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '实收保费（元）',
                        calcTtile: name => {
                            return name + '实收保费（元）';
                        },
                        key: 'receiptFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span onClick={() => vm.goPolicyList(2, row)} class="can-click">
                                    {number_format(row.receiptFee, 2)}元
                                </span>
                            );
                        }
                    },
                    {
                        title: calculate + '实收数据范围',
                        calcTtile: name => {
                            return name + '实收数据范围';
                        },
                        key: 'receiptTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const date = params.row.receiptTimeBegin.substring(0, 10);
                            const endDate = params.row.receiptTimeEnd.substring(0, 10);
                            return (
                                <span>
                                    {date} 至 {endDate}
                                </span>
                            );
                        }
                    }
                    // {
                    //     title: '操作',
                    //     slot: 'action',
                    //     align: 'center',
                    //     width: '100',
                    //     fixed: 'right'
                    // }
                ];
            } else if (this.type == 4) {
                this.columns = [
                    {
                        type: 'index',
                        title: '序号',
                        align: 'center',
                        width: '80'
                    },
                    {
                        title: '继续率月份',
                        key: 'month',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span>
                                    {row.year}-{row.month < 10 ? '0' + row.month : row.month}
                                </span>
                            );
                        }
                    },
                    {
                        title: '业务员',
                        key: 'groupName',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span>
                                    {row.salesManCode}/{row.salesManName}
                                </span>
                            );
                        }
                    },
                    {
                        title: map[this.searchParams.owerType],
                        calcTtile: () => {
                            return map[this.searchParams.owerType];
                        },
                        key: 'owerName',
                        minWidth: 140,
                        align: 'center'
                    },

                    {
                        title: '继续率指标',
                        slot: 'rateMode',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: '继续率',
                        key: 'rate',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return <span>{row.rate}%</span>;
                        }
                    },
                    {
                        title: calculate + '承保保费（元）',
                        calcTtile: name => {
                            return name + '承保保费（元）';
                        },
                        key: 'insureFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                return (
                                    <span onClick={() => vm.goPolicyList(1, row)} class="can-click">
                                        {number_format(row.insureFee, 2)}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '承保数据范围',
                        calcTtile: name => {
                            return name + '承保数据范围';
                        },
                        key: 'insureTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                const date = row.insureTimeBegin.substring(0, 10);
                                const endDate = row.insureTimeEnd.substring(0, 10);
                                return (
                                    <span>
                                        {date} 至 {endDate}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '实收保费（元）',
                        calcTtile: name => {
                            return name + '实收保费（元）';
                        },
                        key: 'receiptFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span onClick={() => vm.goPolicyList(2, row)} class="can-click">
                                    {number_format(row.receiptFee, 2)}元
                                </span>
                            );
                        }
                    },
                    {
                        title: calculate + '实收数据范围',
                        calcTtile: name => {
                            return name + '实收数据范围';
                        },
                        key: 'receiptTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const date = params.row.receiptTimeBegin.substring(0, 10);
                            const endDate = params.row.receiptTimeEnd.substring(0, 10);
                            return (
                                <span>
                                    {date} 至 {endDate}
                                </span>
                            );
                        }
                    }
                    // {
                    //     title: '操作',
                    //     slot: 'action',
                    //     align: 'center',
                    //     width: '100',
                    //     fixed: 'right'
                    // }
                ];
            } else if (this.type == 5) {
                this.columns = [
                    {
                        type: 'index',
                        title: '序号',
                        align: 'center',
                        width: '80'
                    },
                    {
                        title: '继续率月份',
                        key: 'month',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span>
                                    {row.year}-{row.month < 10 ? '0' + row.month : row.month}
                                </span>
                            );
                        }
                    },
                    {
                        title: '签约机构',
                        key: 'topOrgName',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: map[this.searchParams.owerType],
                        calcTtile: () => {
                            return map[this.searchParams.owerType];
                        },
                        key: 'owerName',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: '是否包含下级机构数据',
                        key: 'hasSubOrg',
                        minWidth: 160,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return <span>{vm.searchParams.hasSubOrg == 1 ? '是' : '否'}</span>;
                        }
                    },
                    {
                        title: '继续率指标',
                        slot: 'rateMode',
                        minWidth: 140,
                        align: 'center'
                    },
                    {
                        title: '继续率',
                        key: 'rate',
                        minWidth: 140,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            return <span>{row.rate}%</span>;
                        }
                    },
                    {
                        title: calculate + '承保保费（元）',
                        calcTtile: name => {
                            return name + '承保保费（元）';
                        },
                        key: 'insureFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                return (
                                    <span onClick={() => vm.goPolicyList(1, row)} class="can-click">
                                        {number_format(row.insureFee, 2)}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '承保数据范围',
                        calcTtile: name => {
                            return name + '承保数据范围';
                        },
                        key: 'insureTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (lastLabel && row.isLastYear == 1) {
                                return <span></span>;
                            } else {
                                const date = row.insureTimeBegin.substring(0, 10);
                                const endDate = row.insureTimeEnd.substring(0, 10);
                                return (
                                    <span>
                                        {date} 至 {endDate}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: calculate + '实收保费（元）',
                        calcTtile: name => {
                            return name + '实收保费（元）';
                        },
                        key: 'receiptFee',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            return (
                                <span onClick={() => vm.goPolicyList(2, row)} class="can-click">
                                    {number_format(row.receiptFee, 2)}元
                                </span>
                            );
                        }
                    },
                    {
                        title: calculate + '实收数据范围',
                        calcTtile: name => {
                            return name + '实收数据范围';
                        },
                        key: 'receiptTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const date = params.row.receiptTimeBegin.substring(0, 10);
                            const endDate = params.row.receiptTimeEnd.substring(0, 10);
                            return (
                                <span>
                                    {date} 至 {endDate}
                                </span>
                            );
                        }
                    }
                    // {
                    //     title: '操作',
                    //     slot: 'action',
                    //     align: 'center',
                    //     width: '100',
                    //     fixed: 'right'
                    // }
                ];
            }
            // }
            this.changeTarget(this.searchParams.target);
            if (this.type != 1) {
                this.changeSupplierType(this.searchParams.supplierType);
            }
            if (lastLabel && !this.columns.find(i => i.lastReceiptFee)) {
                this.columns.push(
                    {
                        title: lastLabel + '实收保费（元）',
                        calcTtile1: name => {
                            return name + '承保保费（元）';
                        },
                        key: 'lastReceiptFee',
                        minWidth: 180,
                        align: 'center',
                        render(h, params) {
                            const row = params.row;
                            if (row.isLastYear == 0) {
                                return <span></span>;
                            } else {
                                return (
                                    <span onClick={() => vm.goPolicyList(3, row)} class="can-click">
                                        {number_format(row.lastReceiptFee, 2)}
                                    </span>
                                );
                            }
                        }
                    },
                    {
                        title: lastLabel + '实收数据范围',
                        calcTtile1: name => {
                            return name + '实收数据范围';
                        },
                        key: 'lastReceiptTimeBegin',
                        align: 'center',
                        minWidth: 180,
                        render(h, params) {
                            const row = params.row;
                            if (row.isLastYear == 0) {
                                return <span></span>;
                            } else if (row.lastReceiptTimeBegin && row.lastReceiptTimeEnd) {
                                const date = row.lastReceiptTimeBegin.substring(0, 10);
                                const endDate = row.lastReceiptTimeEnd.substring(0, 10);
                                return (
                                    <span>
                                        {date} 至 {endDate}
                                    </span>
                                );
                            }
                        }
                    }
                );
            }
        }
    }
};
